import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import {
  DividerComponent,
  FileSizePipe,
  IconComponent,
  SpinnerComponent,
} from '@core/user-interface-legacy';

import type { AttachmentPlaceloader } from './attachment-placeloader.types';
@Component({
  selector: 'rt-attachment-placeloader',
  templateUrl: 'attachment-placeloader.component.html',
  styleUrls: [
    '../attachment-item/attachment-item.component.less',
    './attachment-placeloader.component.less',
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DividerComponent, FileSizePipe, IconComponent, SpinnerComponent],
})
export class AttachmentPlaceloaderComponent {
  @Input() public attachmentPlaceloader: AttachmentPlaceloader;
}
